export const roomData = {
    title: 'VS Room 101',
    address: 'TN-101',
    street: 'Vita Student Crosshall Street',
    bedCount: '1 bed',
    floor: 'Floor 31',
    date: '2024 / 25',
};

export const studentLimit = 5;
export const initialStudentNumber = 1;

export const bookingLengthOptions = [
    { value: 51, title: '51 WEEKS', subtitle: '7th Sept 2024 - 9th Aug 2025' },
    { value: 44, title: '44 WEEKS', subtitle: '7th Sept 2024 - 9th May 2025' },
];
export const initialBookingLength = 51;

export const instalmentOptions = [
    { value: 438.9, title: '£438.90/pw', subtitle: '1 instalment' },
    { value: 452.8, title: '£452.80/pw', subtitle: '2 instalments' },
    { value: 461.98, title: '£461.98/pw', subtitle: '4 instalments' },
];
export const initialInstalmentPlan = 438.9;

export const paymentPlanData = {
    advancedLicenceFee: {
        paymentLocale: 'payment_plan_advanced_licence_fee',
        weeks: '2',
        due_date: '01/09/25',
        amount: '1567.45',
    },
    instalment1: {
        paymentLocale: 'payment_plan_instalment_1',
        weeks: '49',
        due_date: '01/09/25',
        amount: '11567.89',
        withBorder: true,
    },
    subtotal: {
        paymentLocale: 'payment_plan_subtotal',
        weeks: '',
        due_date: '',
        amount: '12567.45',
    },
    discount: {
        paymentLocale: 'payment_plan_discount',
        weeks: '',
        due_date: '',
        amount: '-1567.45',
        isDiscount: true,
    },
    totalPayable: {
        paymentLocale: 'payment_plan_total_payable',
        weeks: '',
        due_date: '',
        amount: '11567.45',
        withBorder: true,
    },
};

export const rent = {
    paymentLocale: 'payment_plan_rent',
    amount: '£456.65/PW',
};

export const totalPaymentData = {
    paymentLocale: 'payment_plan_total_payable_today',
    amount: '1567.45',
};
